// @ts-expect-error tinymce not typed
import tinymce from 'tinymce';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/noneditable';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/print';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import http from 'hub-http/clients/apiClient';
import { getStaticUrl, getStaticPrefix } from 'rich-text-lib/utils/staticUrl';
// @ts-expect-error CANVAS_INLINE not typed
import { CANVAS_INLINE } from 'tinymce-themes/themes/canvas-inline';
import 'tinymce-plugins/hsformatting';
import 'tinymce-plugins/hslink';
import 'tinymce-plugins/hspaste';
import 'tinymce-plugins/hsmedia';
import 'tinymce-plugins/hsvideo';
import 'tinymce-plugins/hsimage';
import 'tinymce-plugins/hsemoji';
import 'tinymce-plugins/hsi18n';
import 'tinymce-plugins/hsnewline';
import 'tinymce-plugins/hslists';
import 'tinymce-plugins/hstable2';
import 'tinymce-plugins/hsanchor';
import 'tinymce-plugins/hscallout';
import 'tinymce-plugins/hscharmap';
import 'tinymce-plugins/hscontentgeneration';
import 'tinymce-plugins/hsfindreplace';
import 'tinymce-plugins/hshr';
import 'tinymce-plugins/hscore';
import { getIframeUploadFile } from 'tinymce-data/api/FileManager';
// @ts-expect-error getUploadHandler not typed
import { getUploadHandler } from 'tinymce-plugins/hsimage/utils/uploadHandler';
import { LINK_SETTINGS, hslinkConfig } from 'tinymce-plugins/constants/hslink';
import { HS_INPAGE, HS_PLUGINS } from 'tinymce-plugins/constants/hsSettings';
import { HS_FORMATTING, HS_LINK, HS_IMAGE, HS_VIDEO_V2, HS_MEDIA, HS_PASTE, HS_EMOJI, HS_I18N, HS_NEWLINE, HS_LISTS, HS_TABLE_V2, HS_ANCHOR, HS_CALLOUT, HS_CHARMAP, HS_FIND_REPLACE, HS_HR, HS_CORE, HS_CONTENT_GENERATION } from 'tinymce-plugins/constants/plugins';
import { DUMMY_LANG_URL } from 'tinymce-plugins/constants/hsi18n';
import { CALLOUT_SELECTOR } from 'tinymce-plugins/constants/hscallout';
import { IMAGE_SETTINGS, hsimageConfig } from 'tinymce-plugins/constants/image';
import { MEDIA_SETTINGS, hsmediaConfig } from 'tinymce-plugins/constants/hsMedia';
import { VIDEO_SETTINGS, hsvideoConfig } from 'tinymce-plugins/constants/hsvideo';
import { hsformattingConfig } from 'tinymce-plugins/constants/hsformatting';
import { PASTE_SETTINGS, hspasteConfig } from 'tinymce-plugins/constants/hspaste';
import { TABLE_SETTINGS, hstableConfig } from 'tinymce-plugins/constants/hstable2';
import { HR_SETTINGS, hshrConfig } from 'tinymce-plugins/constants/hshr';
import { CONTENT_ASSISTANT_SETTINGS, hsContentAssistantConfig } from 'tinymce-plugins/constants/hscontentgeneration';
import { Alignments } from 'rich-text-lib/constants/alignments';
import { ImageAlignmentClasses } from 'rich-text-lib/constants/image';
import { settings, getPasteDefaultTableStyles } from '../defaults';
import { knowledgeBaseSchema } from '../../schemas/knowledge-base';
import { getLanguage } from '../../utils/getLanguage';
import { getGated, hasScope } from '../../utils/auth';
import { getCanvasToolbar } from '../../toolbar/knowledge-base';
import { lineHeightsList, fontFormatList, getDefaultTableStyles, getDefaultTableCellStyles, HS_VIDEO_ADVANCED_LEAD_GEN_SCOPE } from '../../Constants';
import { getShouldStripImageBlobs } from '../utils';
const getBlockFormats = (h1Tooltip, h2Tooltip) => [{
  title: 'Paragraph',
  format: 'p'
}, {
  title: 'Heading 1',
  format: 'h1',
  disabled: true,
  tooltip: h1Tooltip
}, {
  title: 'Heading 2',
  format: 'h2',
  disabled: true,
  tooltip: h2Tooltip
}, {
  title: 'Heading 3',
  format: 'h3'
}, {
  title: 'Heading 4',
  format: 'h4'
}, {
  title: 'Blockquote',
  format: 'blockquote'
}, {
  title: 'Code block',
  format: 'pre'
}];
const getDefaultMediaStyles = () => ({
  margin: '10px auto',
  display: 'block',
  clear: 'both'
});
const Plugins = ['lists', 'paste', 'print', 'searchreplace', 'noneditable', HS_CORE, HS_FORMATTING, HS_HR, HS_LINK, HS_PASTE, HS_IMAGE, HS_MEDIA, HS_CHARMAP, HS_EMOJI, HS_I18N, HS_NEWLINE, HS_LISTS, 'table', HS_TABLE_V2, HS_ANCHOR, HS_VIDEO_V2, HS_CALLOUT, HS_FIND_REPLACE];
const GatedMap = {};
const resizableImageSelector = `img:not(.${ImageAlignmentClasses[Alignments.LEFT]}):not(.${ImageAlignmentClasses[Alignments.RIGHT]})`;
const shouldDisableResizing = (editor, image) => !editor.dom.is(image, resizableImageSelector);
export function getConfig(options = {}) {
  const {
    appName,
    usageTracker,
    toolbarContainer,
    FileManagerComponent,
    pickerComponents,
    gates = [],
    scopes = [],
    maxContainerWidth = 600,
    h1Tooltip,
    h2Tooltip,
    toolbarTooltip,
    uploadedFileAccess,
    stripImageBlobs: _stripImageBlobs,
    useContentGeneration = false,
    hsContentAssistant = {}
  } = options;
  const stripImageBlobs = getShouldStripImageBlobs(_stripImageBlobs, scopes);
  if (useContentGeneration) {
    Plugins.push(HS_CONTENT_GENERATION);
  }
  const gated = getGated(GatedMap, gates);
  const plugins = [...Plugins, ...gated.plugins].join(' ');

  // Make sure that the base URL used to fetch localizations and plugins
  // that haven't been added to the bundle is correct. While a mutation
  // in a getter is a faux pas, this avoids requiring the app to set
  // the value correctly.
  tinymce.baseURL = getStaticUrl('tinymce', '/js/tinymce');
  const useConversionAssetOptionsPanel = hasScope(HS_VIDEO_ADVANCED_LEAD_GEN_SCOPE, scopes);
  return Object.assign({}, settings, {
    inline: true,
    content_css: '',
    // Use custom set of valid elements so that only the HTML elements that are supported
    // via the TinyMCE UI are allowed in the content
    valid_elements: knowledgeBaseSchema,
    // Reset extended_valid_elements from settings, but allow script embeds
    extended_valid_elements: `script[*]`,
    browser_spellcheck: true,
    plugins,
    canvasToolbar: getCanvasToolbar(),
    persistToolbar: true,
    toolbarTooltip,
    useTableContextualToolbar: true,
    // handler used to automatically upload pasted and drag-n-dropped images
    images_upload_handler: getUploadHandler({
      inpage: false,
      appName,
      usageTracker,
      uploadFile: getIframeUploadFile.bind(null, http, uploadedFileAccess),
      stripImageBlobs
    }),
    menubar: false,
    table_default_styles: getDefaultTableStyles(),
    table_default_attributes: {},
    // selector for element where inline toolbar will be rendered
    fixed_toolbar_container: toolbarContainer,
    // enable uploading of pasted images
    paste_data_images: true,
    // Allow text to be at the document root,
    // but force paragraphs on carriage return
    forced_root_block: false,
    force_p_newlines: Boolean(tinymce.majorVersion === '4'),
    legacy_force_p_newlines: true,
    // for tinymce@6 (v5.9.0)

    // the skin should be added to the CSS bundle of the app
    skin: false,
    theme: CANVAS_INLINE,
    statusbar: false,
    language: getLanguage(),
    language_url: DUMMY_LANG_URL,
    media_live_embeds: true,
    apiClient: http,
    automatic_uploads: true,
    toolbar: [],
    [HS_INPAGE]: false,
    [HS_PLUGINS]: {
      appName,
      usageTracker,
      FileManagerComponent,
      pickerComponents,
      isEmail: false,
      richTextLibStaticPrefix: getStaticPrefix('rich-text-lib'),
      [IMAGE_SETTINGS]: {
        [hsimageConfig.DISABLE_RESIZING_PREDICATE]: shouldDisableResizing,
        [hsimageConfig.DISABLE_SPACING]: true,
        [hsimageConfig.USE_ALIGNMENT_CLASSES]: true,
        [hsimageConfig.MAX_DIMENSION_WIDTH]: maxContainerWidth,
        [hsimageConfig.STRIP_IMAGE_BLOBS]: stripImageBlobs,
        [hsimageConfig.USE_CUSTOM_ALT_TEXT]: true
      },
      [LINK_SETTINGS]: {
        [hslinkConfig.HIDE_TARGET_BLANK_AND_NO_FOLLOW]: false,
        [hslinkConfig.ALLOW_RELATIVE_LINKS]: true,
        [hslinkConfig.ALLOW_MEETING_LINKS]: true,
        [hslinkConfig.ALLOW_ANCHOR_LINKS]: true
      },
      [HS_FORMATTING]: {
        [hsformattingConfig.FONT_FORMATS]: {
          defaults: fontFormatList
        },
        [hsformattingConfig.FONT_SIZE_FORMATS]: [],
        [hsformattingConfig.LINE_HEIGHTS]: lineHeightsList,
        [hsformattingConfig.APPLY_LINE_HEIGHT_PERCENTAGE]: true,
        [hsformattingConfig.BLOCK_FORMATS]: getBlockFormats(h1Tooltip, h2Tooltip),
        [hsformattingConfig.KEYBOARD_ESCAPE_FORMATS]: ['pre', 'blockquote', CALLOUT_SELECTOR]
      },
      [MEDIA_SETTINGS]: {
        [hsmediaConfig.DISABLE_ALIGNMENT]: true,
        [hsmediaConfig.DISABLE_SPACING]: true,
        [hsmediaConfig.DEFAULT_STYLES]: getDefaultMediaStyles(),
        [hsmediaConfig.MAX_DIMENSION_WIDTH]: maxContainerWidth
      },
      [VIDEO_SETTINGS]: {
        [hsvideoConfig.DISABLE_SPACING]: true,
        [hsvideoConfig.DISABLE_ALIGNMENT]: true,
        [hsvideoConfig.MAX_DIMENSION_WIDTH]: maxContainerWidth,
        [hsvideoConfig.ENABLE_FULL_WIDTH]: true,
        [hsvideoConfig.USE_EMBED]: true,
        [hsvideoConfig.USE_CONVERSION_ASSET_OPTIONS_PANEL]: useConversionAssetOptionsPanel
      },
      [PASTE_SETTINGS]: {
        [hspasteConfig.FORMAT_TRANSFORM_MAP]: {
          H1: 'H3',
          H2: 'H4',
          H5: 'H4',
          H6: 'H4'
        },
        [hspasteConfig.CLEAR_ALL_STYLES]: true,
        [hspasteConfig.DEFAULT_STYLES_MAP]: {
          TABLE: getPasteDefaultTableStyles()
        },
        [hspasteConfig.DEFAULT_ATTRIBUTES_MAP]: {
          TABLE: {}
        },
        [hspasteConfig.EMBED_URL_PASTING]: true,
        [hspasteConfig.IMAGES_UPLOAD_FILE_ACCESS]: uploadedFileAccess
      },
      [TABLE_SETTINGS]: {
        [hstableConfig.MAX_DIMENSION_WIDTH]: maxContainerWidth,
        [hstableConfig.DISABLE_SPACING]: true,
        [hstableConfig.HIDE_CELL_COLOR_OPTIONS]: true,
        [hstableConfig.USE_ALIGNMENT_CLASSES]: true,
        [hstableConfig.DEFAULT_CELL_STYLES]: getDefaultTableCellStyles()
      },
      [HR_SETTINGS]: {
        [hshrConfig.DISABLE_INSERTION]: true
      },
      [CONTENT_ASSISTANT_SETTINGS]: {
        [hsContentAssistantConfig.IS_DISABLED]: hsContentAssistant.isDisabled,
        [hsContentAssistantConfig.SELECTION_COMMANDS]: hsContentAssistant.selectionCommands
      }
    },
    gates,
    scopes
  });
}